/* ============================================================
   CarPosters™ — AI Custom Poster Generator
   ============================================================ */
(function () {
  'use strict';

  function resizeToBase64(dataUrl, maxPx) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.onload = function () {
        var w = img.width, h = img.height;
        if (w > maxPx || h > maxPx) {
          if (w > h) { h = Math.round(h * maxPx / w); w = maxPx; }
          else       { w = Math.round(w * maxPx / h); h = maxPx; }
        }
        var c = document.createElement('canvas');
        c.width = w; c.height = h;
        c.getContext('2d').drawImage(img, 0, 0, w, h);
        resolve(c.toDataURL('image/jpeg', 0.88));
      };
      img.src = dataUrl;
    });
  }

  function CPG() {
    var configEl = document.getElementById('cpg-config');
    if (!configEl) return;
    var config;
    try { config = JSON.parse(configEl.textContent); }
    catch (e) { console.error('CPG config error', e); return; }

    this.api      = config.api      || '';
    this.variants = config.variants || {};
    this.prices   = config.prices   || {};
    this.images       = [null, null, null];
    this.generatedUrl = null;
    this.size         = '40x50';
    this.frame        = 'no';

    this._bind();
    this._updatePrices();
  }

  CPG.prototype._key = function () { return this.size + '-' + this.frame; };

  CPG.prototype._updatePrices = function () {
    var elNo  = document.getElementById('cpg-price-no');
    var elYes = document.getElementById('cpg-price-yes');
    if (elNo)  elNo.textContent  = (this.prices[this.size + '-no']  || '—') + ' €';
    if (elYes) elYes.textContent = (this.prices[this.size + '-yes'] || '—') + ' €';
    ['30x40','40x50','50x70'].forEach(function (s) {
      var el = document.getElementById('cpg-sp-' + s);
      if (el) el.textContent = (this.prices[s + '-' + this.frame] || '—') + ' €';
    }.bind(this));
    var lbl = document.getElementById('cpg-price-label');
    if (lbl) lbl.textContent = (this.prices[this._key()] || '—') + ' €';
  };

  CPG.prototype._bind = function () {
    var self = this;
    [0,1,2].forEach(function (i) {
      var inp = document.getElementById('cpg-img-' + i);
      if (inp) inp.addEventListener('change', function (e) { self._onFile(e, i); });
    });
    document.querySelectorAll('.cpg-slot-remove').forEach(function (btn) {
      btn.addEventListener('click', function () { self._removeImg(+btn.dataset.slot); });
    });
    document.querySelectorAll('input[name="cpg-size"]').forEach(function (r) {
      if (r.checked) { self.size = r.value; r.closest('.cpg-size-card').classList.add('selected'); }
      r.addEventListener('change', function () {
        document.querySelectorAll('.cpg-size-card').forEach(function (c) { c.classList.remove('selected'); });
        r.closest('.cpg-size-card').classList.add('selected');
        self.size = r.value; self._updatePrices();
      });
    });
    document.querySelectorAll('input[name="cpg-frame"]').forEach(function (r) {
      if (r.checked) { self.frame = r.value; r.closest('.cpg-frame-card').classList.add('selected'); }
      r.addEventListener('change', function () {
        document.querySelectorAll('.cpg-frame-card').forEach(function (c) { c.classList.remove('selected'); });
        r.closest('.cpg-frame-card').classList.add('selected');
        self.frame = r.value; self._updatePrices();
      });
    });
    var g = document.getElementById('cpg-gen-btn');
    var rg = document.getElementById('cpg-regen-btn');
    var o = document.getElementById('cpg-order-btn');
    if (g)  g.addEventListener('click',  function () { self._generate(); });
    if (rg) rg.addEventListener('click', function () { self._generate(); });
    if (o)  o.addEventListener('click',  function () { self._order(); });
  };

  CPG.prototype._onFile = function (e, slot) {
    var file = e.target.files[0];
    if (!file) return;
    var self = this;
    var reader = new FileReader();
    reader.onload = function (ev) {
      resizeToBase64(ev.target.result, 1024).then(function (b64) {
        self.images[slot] = b64;
        var prev  = document.getElementById('cpg-prev-' + slot);
        var wrap  = document.querySelector('#cpg-slot-' + slot + ' .cpg-slot-preview');
        var label = document.querySelector('#cpg-slot-' + slot + ' .cpg-slot-label');
        if (prev)  prev.src = b64;
        if (wrap)  wrap.style.display  = 'block';
        if (label) label.style.display = 'none';
      });
    };
    reader.readAsDataURL(file);
  };

  CPG.prototype._removeImg = function (slot) {
    this.images[slot] = null;
    var inp   = document.getElementById('cpg-img-' + slot);
    var wrap  = document.querySelector('#cpg-slot-' + slot + ' .cpg-slot-preview');
    var label = document.querySelector('#cpg-slot-' + slot + ' .cpg-slot-label');
    if (inp)   inp.value = '';
    if (wrap)  wrap.style.display  = 'none';
    if (label) label.style.display = 'flex';
  };

  CPG.prototype._validate = function () {
    if (!this.images[0]) { this._err('Моля качете поне една снимка.'); return false; }
    var m = document.getElementById('cpg-model').value.trim();
    var y = document.getElementById('cpg-year').value.trim();
    var e = document.getElementById('cpg-engine').value.trim();
    var h = document.getElementById('cpg-hp').value.trim();
    if (!m || !y || !e || !h) { this._err('Моля попълнете всички данни за колата.'); return false; }
    if (!this.api) { this._err('API не е конфигуриран.'); return false; }
    return { model: m, year: y, engine: e, hp: h };
  };

  CPG.prototype._generate = function () {
    var car = this._validate();
    if (!car) return;
    var self = this;
    var btn  = document.getElementById('cpg-gen-btn');
    var idle = btn.querySelector('.cpg-btn-idle');
    var busy = btn.querySelector('.cpg-btn-busy');
    var prev = document.getElementById('cpg-preview');
    var err  = document.getElementById('cpg-error');

    btn.disabled = true;
    idle.style.display = 'none';
    busy.style.display = 'inline-flex';
    if (err)  err.style.display  = 'none';
    if (prev) prev.style.display = 'none';

    fetch(self.api, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        images: self.images.filter(Boolean),
        carModel: car.model, year: car.year,
        engine: car.engine, horsepower: car.hp
      })
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw new Error(d.details || d.error || 'API error'); });
      return r.json();
    })
    .then(function (data) {
      if (!data.imageUrl) throw new Error('Не получихме изображение.');
      self.generatedUrl = data.imageUrl;
      // Save in sessionStorage so we can retrieve it for the order note
      try { sessionStorage.setItem('cpg_poster_url', data.imageUrl); } catch(e) {}
      var img = document.getElementById('cpg-result-img');
      if (img) img.src = data.imageUrl;
      if (prev) { prev.style.display = 'block'; prev.scrollIntoView({ behavior:'smooth', block:'start' }); }
    })
    .catch(function (e) { self._err('Грешка: ' + e.message); })
    .finally(function () {
      btn.disabled = false;
      idle.style.display = 'inline-flex';
      busy.style.display = 'none';
    });
  };

  CPG.prototype._order = function () {
    if (!this.generatedUrl) return;
    var self      = this;
    var variantId = self.variants[self._key()];
    var orderBtn  = document.getElementById('cpg-order-btn');

    if (!variantId) {
      self._err('Не е намерен вариант. Моля свържете се с нас.');
      return;
    }

    var model  = document.getElementById('cpg-model').value.trim();
    var year   = document.getElementById('cpg-year').value.trim();
    var engine = document.getElementById('cpg-engine').value.trim();
    var hp     = document.getElementById('cpg-hp').value.trim();

    // Only include short text properties — image URL goes in cart note
    var isBase64 = self.generatedUrl.indexOf('data:') === 0;
    var posterRef = isBase64 ? '(генерирано — виж бележката)' : self.generatedUrl.substring(0, 200);

    orderBtn.disabled  = true;
    orderBtn.innerHTML = '<span class="cpg-spin" style="border-top-color:#000"></span> Добавя се…';

    // Step 1: Add to cart (short properties only)
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id:       parseInt(variantId, 10),
        quantity: 1,
        properties: {
          'Модел':       model,
          'Година':      year,
          'Двигател':    engine,
          'Конски сили': hp + ' HP',
          'Размер':      self.size + ' cm',
          'Рамка':       self.frame === 'yes' ? 'С рамка' : 'Без рамка'
        }
      })
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Cart error'); });
      // Step 2: Add poster URL as cart note
      var noteText = 'ПОСТЕР: ' + model + ' ' + year + '\nURL: ' + self.generatedUrl;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: noteText })
      });
    })
    .then(function () {
      // Step 3: Open cart or redirect
      var cartBtn = document.querySelector('[data-cart-drawer-toggle], .cart-drawer-toggle, #cart-icon-bubble');
      if (cartBtn) {
        cartBtn.click();
        orderBtn.disabled  = false;
        orderBtn.innerHTML = '✓ Добавено в количката';
      } else {
        window.location.href = '/cart';
      }
    })
    .catch(function (e) {
      self._err('Грешка при добавяне: ' + e.message);
      orderBtn.disabled  = false;
      orderBtn.innerHTML = '🛒 Поръчай Постера';
    });
  };

  CPG.prototype._err = function (msg) {
    var box = document.getElementById('cpg-error');
    var txt = document.getElementById('cpg-error-msg');
    if (!box) return;
    if (txt) txt.textContent = msg;
    box.style.display = 'flex';
    box.scrollIntoView({ behavior:'smooth', block:'nearest' });
  };

  function init() {
    if (document.getElementById('cpg-root')) new CPG();
  }
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
